/**
 * Created by dx.yang on 2017/3/20.
 */
import Vue from 'vue';

export default {
    list: [],
    total: 0,
    imgsys: [],
    copyRegions: [],
    tagKeySet: {},
    colsFilterChecked: ['imageName', 'imageSize', 'imageType', 'status', 'os', 'createTime', 'supportFastBoot', 'azCode', 'operation'],
    imageColsAll: [{
        name: Vue.$trans(`镜像名称`),
        id: 'imageName',
        disabled: true
    }, {
        name: Vue.$trans(`系统大小`),
        id: 'imageSize',
        disabled: false
    }, {
        name: Vue.$trans(`镜像类型`),
        id: 'imageType',
        disabled: false
    }, {
        name: Vue.$trans(`启动模式`),
        id: 'imageMode',
        disabled: false
    }, {
        name: Vue.$trans(`状态`),
        id: 'status',
        disabled: false
    }, {
        name: Vue.$trans(`极速可用状态`),
        id: 'localImagestatus',
        disabled: false
    }, {
        name: Vue.$trans(`操作系统`),
        id: 'os',
        disabled: false
    }, {
        name: Vue.$trans(`创建时间`),
        id: 'createTime',
        disabled: false
    }, {
        name: Vue.$trans(`是否支持快速开机`),
        id: 'supportFastBoot',
        disabled: false
    }, {
        name: Vue.$trans(`可用区`),
        id: 'azCode',
        disabled: false
    }, {
        name: Vue.$trans(`操作`),
        id: 'operation',
        disabled: true
    }, {
        name: Vue.$trans(`镜像描述`),
        id: 'imageDesc',
        disabled: false
    }, {
        name: Vue.$trans(`关联快照`),
        id: 'associatedSnapshot',
        disabled: false
    }],
    //默认不展示的列
    defaultOmit: [],
    get imageCols() {
        return _.omitBy(this.imageColsAll, item => {
            return item.id == 'group'
        });
    },
    set listChecked(value) {
        return value;
    },
    get listChecked() {
        let me = this,
            arr = [];
        let omit;
        try {
            omit = JSON.parse(localStorage.imageOmitList) || this.defaultOmit;
        } catch (e) {
            omit = this.defaultOmit;
        }
        _.forEach(this.imageColsAll, item => {
            if (_.indexOf(omit, item.id) == -1) {
                arr.push(item.id);
            }
        });
        // console.log(omit, arr, 12312321);
        return arr;
    },
    set tagsChecked(value) {
        return value
    },
    get tagsChecked() {
        //展示的tags
        try {
            return JSON.parse(localStorage.imageTagsChecked) || [];
        } catch (e) {
            return [];
        }
    },
};
